<template>
    <section>
      <div class="padding-sm-all padding-lg-bottom" v-if="localShipment.id">
        <el-form label-position="top" :rules="rules" ref="create-shipment-form" :model="localShipment" label-width="150px" @submit.prevent.native="validatorBeforeSubmit">
          <el-row :gutter="20" class="remove-margin border-bottom">
            <el-col :span="12">
              <h2 class="shipment-block"><i class="fa fa-user"></i>&nbsp;Thông tin người nhận</h2>
              <el-form-item label="Tên" prop="receiver.name">
                <el-input v-model="localShipment.receiver.name" placeholder="Tên">
                  <!-- <template slot="append">
                    <el-popover
                      popper-class="contact-pophover"
                      ref="suggettionReceiver"
                      placement="right"
                      title="Danh bạ"
                      width="400"
                      trigger="click"
                      v-model="suggettionReceiverPop"
                       @show="selectReceiver(searchReceiver)"
                      >
                      <div class="pop-search">
                        <el-input type="text" v-model="searchReceiver" @change="selectReceiver(searchReceiver)" placeholder="Nhập tên, sđt..." > </el-input>
                      </div>
                      <el-row class="padding-all">
                        <el-col :span="24" v-show="!listReceiver.length && !fetchReceiver">
                          <div class="text-red text-center">Không có dữ liệu</div>
                        </el-col>
                        <el-col v-if="fetchReceiver" :span="24">
                          <div class="text-center">
                            <i class="fa fa-spinner fa-spin"></i>
                          </div>
                        </el-col>
                        <el-col v-else :span="24"
                          class="contact-row"
                          v-for="item in listReceiver"
                          :key="item.id"
                          :value="item"
                          >
                        <div class="pointer" @click="selectSuggettionReceiver(item)">
                          <p><i class="fa fa-user"></i> {{item.name}}</p>
                          <p><i class="fa fa-phone"></i> {{item.phone}}</p>
                          <p v-if="item.addresses && item.addresses.data.length"><i class="fa fa-map-marker"></i> {{item.addresses.data[0].full_street}}</p>
                        </div>
                        </el-col>
                      </el-row>
                    </el-popover>
                    <el-tooltip placement="top" content="Danh bạ" class="display-inline" >
                      <el-button v-popover:suggettionReceiver><i class="fa fa-book"></i></el-button>
                    </el-tooltip>
                  </template> -->
                </el-input>
              </el-form-item>
              <el-form-item label="Điện thoại" prop="receiver.phone">
                <el-input type="number" v-model="localShipment.receiver.phone" placeholder="Điện thoại"></el-input>
              </el-form-item>
              <el-form-item label="Địa chỉ đến" prop="address_to.street">
                <el-input name="address_to.street" v-model="localShipment.address_to.street" placeholder="Địa chỉ đến"></el-input>
              </el-form-item>
              <el-form-item label="Tỉnh thành" prop="address_to.city_code">
                <el-col :span="24">
                  <el-select @change="getDistrictTo(false)" class="display-block" v-model="localShipment.address_to.city_code" filterable placeholder="Chọn tỉnh thành đến">
                    <el-option
                      v-for="city in cities"
                      :key="city.id"
                      :label="city.name"
                      :value="city.code">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="Quận huyện" prop="address_to.district_code">
                <el-col :span="24" class="margin-sm-top">
                  <el-select @change="changeDistrictTo(false)" :disabled="localShipment.address_to && !localShipment.address_to.city_code" class="display-block" v-model="localShipment.address_to.district_code" filterable placeholder="Chọn quận huyện đến">
                    <el-option
                      v-for="district in districtTo"
                      :key="district.id"
                      :label="district.name"
                      :value="district.code">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="Phường xã" prop="address_to.ward_id">
                <el-col :span="24" class="margin-sm-top">
                  <el-select class="display-block" :disabled="localShipment.address_to && !localShipment.address_to.district_code" v-model="localShipment.address_to.ward_id" filterable placeholder="Phường xã đến">
                    <el-option
                      v-for="ward in wardTo"
                      :key="ward.id"
                      :label="ward.name"
                      :value="ward.id.toString()">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
            </el-col>
            <el-col :span="12">
              <h2 class="shipment-block"><i class="fa fa fa-info-circle"></i>&nbsp;Thông tin hàng gửi</h2>              
              <el-form-item label="Tiền thu hộ (COD)" prop="parcel.cod_amount">
                <el-input @focus="removeZero('parcel.cod_amount')" @blur="addZero('parcel.cod_amount')" v-model="localShipment.parcel.cod_amount" placeholder="Tiền thu hộ (COD)">
                  <template slot="append"><span class="text-red">{{localShipment.parcel.cod_amount | vnd}}</span></template>
                </el-input>
              </el-form-item>
              <el-form-item v-if="showUpdateToCarrier" label="Cập nhật tiền thu hộ (COD) sang hãng" prop="update_to_carrier">
                  <el-checkbox :false-label="0" :true-label="1" v-model="localShipment.update_to_carrier"> Cập nhật tiền thu hộ (COD) sang hãng </el-checkbox>
                </el-form-item>
                <el-form-item label="Phí vượt cân" prop="over_weight_fee">
                <el-input
                  @focus="removeZero('over_weight_fee')"
                  @blur="addZero('over_weight_fee')"
                  v-model="localShipment.over_weight_fee"
                  placeholder="Phí vượt cân"
                >
                  <template slot="append"
                    ><span class="text-red">{{
                      localShipment.over_weight_fee | vnd
                    }}</span></template
                  >
                </el-input>
              </el-form-item>
              <el-form-item label="Phí giao lại" prop="re_delivery_fee">
                <el-input
                  @focus="removeZero('re_delivery_fee')"
                  @blur="addZero('re_delivery_fee')"
                  v-model="localShipment.re_delivery_fee"
                  placeholder="Phí giao lại"
                >
                  <template slot="append"
                    ><span class="text-red">{{
                      localShipment.re_delivery_fee | vnd
                    }}</span></template
                  >
                </el-input>
              </el-form-item>
              <el-form-item label="Phí khác" prop="update_info_fee">
                <el-input @focus="removeZero('update_info_fee')" @blur="addZero('update_info_fee')" v-model="localShipment.update_info_fee" placeholder="Phí cập nhật">
                  <template slot="append"><span class="text-red">{{localShipment.update_info_fee | vnd}}</span></template>
                </el-input>
              </el-form-item>
              <el-form-item label="Người thanh toán">
                <el-radio-group :disabled="isCoin" v-model="localShipment.payer" >
                  <el-radio :label="index" v-for="(payer, index) in shipmentHelpers.payers" :key="index">{{payer}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="Ghi chú cập nhật" prop="note_update">
                <el-input type="textarea" :rows="4" v-model="localShipment.note_update" placeholder="Ghi chú cập nhật"></el-input>
              </el-form-item>
              <el-form-item label="Tình trạng đơn hàng">
                <el-checkbox :disabled="!!localShipment.part_delivery || !!localShipment.is_lost || !!localShipment.is_error" :false-label="0" :true-label="1" v-model="localShipment.is_return"> Chuyển hoàn </el-checkbox>
                <el-checkbox :disabled="!!localShipment.is_return || !!localShipment.is_lost || !!localShipment.is_error" :false-label="0" :true-label="1" v-model="localShipment.part_delivery"> Giao một phần </el-checkbox>
                <el-checkbox :disabled="!!localShipment.is_return || !!localShipment.part_delivery || !!localShipment.is_error" :false-label="0" :true-label="1" v-model="localShipment.is_lost"> Thất lạc hàng </el-checkbox>
                <el-checkbox :disabled="!!localShipment.is_return || !!localShipment.part_delivery || !!localShipment.is_lost" :false-label="0" :true-label="1" v-model="localShipment.is_error"> Đơn gửi sang hãng lỗi </el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </section>
  </template>
  
  <script>
  import { head, get, set } from 'lodash'
  import { hardUpdateShipment, getShipment } from 'src/api/shipments'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'UpgradeShipment',
    props: {
      shipmentId: {
        type: String,
        default: ''
      }
    },
    data () {
      let validatorParcelWeight = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Cân nặng không thể để trống'))
        } if (value < 50) {
          callback(new Error('Cân nặng không nhỏ hơn 50g'))
        } else {
          callback()
        }
      }
      return {
        rules: {
          'receiver.name': [
            { required: true, message: 'Tên người nhận không thể để trống', trigger: 'change' },
            { min: 2, max: 255, message: 'Tên người nhận phải chứa từ 2 đến 255 ký tự', trigger: 'change' }
          ],
          'receiver.phone': [
            { required: true, message: 'Điện thoại người nhận không thể để trống', trigger: 'change' },
            { min: 8, max: 12, message: 'Điện thoại người nhận phải chứa từ 8 đến 12 ký tự', trigger: 'change' }
          ],
          'address_from.city_code': [
            { required: true, message: 'Tỉnh thành đi không thể để trống', trigger: 'change' }
          ],
          'address_from.district_code': [
            { required: true, message: 'Quận huyện đi không thể để trống', trigger: 'change' }
          ],
          'address_from.ward_id': [
            { required: true, message: 'Phường xã đi không thể để trống', trigger: 'change' }
          ],
          'address_from.street': [
            { required: true, message: 'Địa chỉ đi không thể để trống', trigger: 'change' },
            { min: 2, max: 255, message: 'Địa chỉ đi phải chứa từ 2 đến 255 ký tự', trigger: 'change' }
          ],
          'picker.name': [
            { required: true, message: 'Tên người gửi không thể để trống', trigger: 'change' },
            { min: 2, max: 255, message: 'Tên người gửi phải chứa từ 2 đến 255 ký tự', trigger: 'change' }
          ],
          'picker.phone': [
            { required: true, message: 'Điện thoại người gửi không thể để trống', trigger: 'change' },
            { min: 8, max: 12, message: 'Điện thoại người gửi phải chứa từ 8 đến 12 ký tự', trigger: 'change' }
          ],
          'address_to.city_code': [
            { required: true, message: 'Tỉnh thành đến không thể để trống', trigger: 'change' }
          ],
          'address_to.district_code': [
            { required: true, message: 'Quận huyện đến không thể để trống', trigger: 'change' }
          ],
          'address_to.street': [
            { required: true, message: 'Địa chỉ đến không thể để trống', trigger: 'change' },
            { min: 5, max: 255, message: 'Địa chỉ đến phải chứa từ 5 đến 255 ký tự', trigger: 'change' }
          ],
          'parcel.weight': [
            { validator: validatorParcelWeight, trigger: 'change' }
          ],
          'parcel.name': [
            { required: true, message: 'Tên gói hàng không được để trống', trigger: 'change' }
          ],
          'note_update': [
            { required: true, message: 'Ghi chú cập nhật không được để trống', trigger: 'change' }
          ]
        },
        submitting: false,
        localShipment: {},
        isCoin: false,
      }
    },
    methods: {
      ...mapActions('shipment', ['getShipmentHelpers']),
      ...mapActions('city', ['getAllCity']),
      ...mapActions('district', ['getAllDistrictTo', 'getAllDistrictFrom']),
      ...mapActions('ward', ['getAllWardFrom', 'getAllWardTo']),
      validatorBeforeSubmit (autoSend) {
        if (autoSend === 1) {
          this.localShipment.auto_send = 1
        } else {
          this.localShipment.auto_send = 0
        }
        this.$refs['create-shipment-form'].validate((valid) => {
          if (valid) {
            this.submitShipment()
            // this.localShipment.metadata = this.metadata + ', ' + this.localShipment.metadata
          } else {
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              type: 'warning'
            })
            this.submitting = false
            return false
          }
        })
      },
      submitShipment (print = false) {
        this.toggleLoadding(true)
        this.changedData = false
        this.watching = false
        this.submitting = true
        hardUpdateShipment(this.localShipment.id, this.localShipment).then(response => {
          this.toggleLoadding(false)
          this.submitting = false
          switch (response.code) {
            case 200:
              this.$store.dispatch('showNotify', {
                title: 'Sửa thành công!',
                body: 'Cập nhật thông tin vận đơn thành công!',
                type: 'success'
              })
              this.$emit('edit-shipment-success')
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              // this.localShipment.metadata = this.localShipment.metadata.replace(this.metadata + ', ', '')
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              })
              break
            case 402:
              this.$store.dispatch('showNotify', {
                title: 'Sửa thành công!',
                body: response.message,
                type: 'warning'
              })
              this.$emit('edit-shipment-success')
              break
            default:
              this.$store.dispatch('showNotify', {
                title: 'Sửa thất bại!',
                body: 'Cập nhật thông tin vận đơn thất bại vui lòng kiểm tra lại thông tin',
                type: 'danger'
              })
          }
        })
      },
      setNewShipment () {
        this.localShipment = {
          id: 0,
          address_from: {
            city_code: '',
            district_code: '',
            ward_id: '',
            street: ''
          },
          address_to: {
            city_code: '',
            district_code: '',
            ward_id: '',
            street: ''
          },
          picker: {
            name: '',
            phone: ''
          },
          receiver: {
            name: '',
            phone: ''
          },
          parcel: {
            quantity: 1,
            cod_amount: 0,
            length: 0,
            width: 0,
            height: 0,
            weight: 0,
            amount: 0,
            name: ''
          },
          metadata: '',
          return_type: 0,
          payer: 0,
          price_table_id: '',
          total_amount_carrier: 0,
          total_amount_shop: 0,
          total_fee: 0,
          promo_code: '',
          discount: 0,
          note_update: '',
          over_weight_fee: 0,
          re_delivery_fee: 0,
          update_info_fee: 0,
          is_return: 0,
          part_delivery: 0,
          is_lost: 0,
          is_error: 0,
          update_to_carrier: 0
        }
      },
      removeZero(key) {
        if (parseInt(get(this.localShipment, key)) === 0) {
          set(this.localShipment, key, '')
        }
      },
      addZero(key) {
        if (get(this.localShipment, key) === '') {
          set(this.localShipment, key, 0)
        }
      },
    },
    computed: {
      ...mapGetters('shipment', ['shipmentHelpers']),
      ...mapGetters('city', ['cities']),
      ...mapGetters('district', ['districtTo', 'districtFrom']),
      ...mapGetters('ward', ['wardFrom', 'wardTo']),
    },
    mounted () {
      this.setNewShipment()
      getShipment(this.shipmentId, {include: 'address_from,address_to,picker,receiver,carrier,service,parcel,price_table,promotion'}).then(response => {
        if (response.code === 200) {
          this.localShipment.address_from = response.data.address_from.data
          this.localShipment.address_from.ward_id = response.data.address_from.data.ward_id.toString()
          this.localShipment.address_to = response.data.address_to.data
          this.localShipment.address_to.ward_id = response.data.address_to.data.ward_id.toString()
          this.localShipment.parcel = response.data.parcel.data
          this.localShipment.parcel.name = response.data.parcel.data.name ? response.data.parcel.data.name : 'gói hàng'
          this.localShipment.picker = response.data.picker.data
          this.localShipment.receiver = response.data.receiver.data
          this.localShipment.return_type = response.data.return_type
          this.localShipment.payer = response.data.payer
          this.localShipment.client_id = response.data.client_id
          this.localShipment.price_table_id = response.data.price_table_id
          this.localShipment.promo_code = response.data.promotion.data.code ? response.data.promotion.data.code : ''
          this.localShipment.metadata = response.data.metadata
          this.localShipment.note_update = response.data.note_update
          this.localShipment.over_weight_fee = response.data.overweight_fee
          this.localShipment.re_delivery_fee = response.data.re_delivery_fee
          this.localShipment.update_info_fee = response.data.update_info_fee
          this.localShipment.is_return = response.data.is_return
          this.localShipment.part_delivery = response.data.is_part_delivery
          this.localShipment.is_lost = response.data.is_lost
          this.localShipment.is_error = response.data.is_error
          this.localShipment.id = response.data.id
          this.localShipment.update_to_carrier = response.data.can_update_cod_to_carrier
          this.showUpdateToCarrier = response.data.can_update_cod_to_carrier
          this.getAllDistrictTo({city_code: this.localShipment.address_to.city_code, limit: -1, sort: 'name:1'})
          this.getAllWardTo({district_code: this.localShipment.address_to.district_code, limit: -1, sort: 'name:1'})
          this.getAllDistrictFrom({city_code: this.localShipment.address_from.city_code, limit: -1, sort: 'name:1'})
          this.getAllWardFrom({district_code: this.localShipment.address_from.district_code, limit: -1, sort: 'name:1'})
          setTimeout(() => {
            this.watching = true
          }, 200)
        } else {
          this.$router.push({name: 'shipment'})
          this.$store.dispatch('showNotify', {
            title: 'Không tìm thấy tài nguyên',
            body: 'Vận đơn không tồn tại trên hệ thống',
            type: 'warning'
          }, {root: true})
        }
      })

      if (!this.cities.length) {
        this.getAllCity({ limit: -1, sort: 'name:1' })
      }
      if (!Object.keys(this.shipmentHelpers).length) {
        this.getShipmentHelpers()
      }
    }
  }
  </script>
  
  <style type="text/css" scoped>
    .fee-display{
      line-height: 50px;
    }
    .list-fee{
      border-bottom: 1px solid #444;
    }
    .shipment-block{
      border-bottom: 1px solid #ddd;
      padding-left: 5px;
    }
  </style>
  


// WEBPACK FOOTER //
// UpgradeShipment.vue?debee382